// Recent Explore searches, persisted in localStorage (last 5, newest first).
// Same lightweight persistence pattern as the theme (see ThemeContext).

const STORAGE_KEY = 'lumoz-explore-recent-searches';
const MAX_RECENTS = 5;

export function getRecentSearches() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((s) => typeof s === 'string') : [];
  } catch {
    return [];
  }
}

// Add a query to the front, de-duplicated (case-insensitive), capped at MAX_RECENTS.
// Returns the new list so callers can update state without a re-read.
export function addRecentSearch(query) {
  const q = (query || '').trim();
  if (!q) return getRecentSearches();
  const existing = getRecentSearches().filter((s) => s.toLowerCase() !== q.toLowerCase());
  const next = [q, ...existing].slice(0, MAX_RECENTS);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore quota/availability errors — recents are best-effort
  }
  return next;
}
